import { castToOption } from 'src/helpers';
import type { ISelectOption } from 'src/types/ISelectOption';

export enum SpecificationEnumDisplayMode {
  DEFAULT = 'DEFAULT',
  DROPDOWN = 'DROPDOWN',
  TILES = 'TILES',
}

export const SPECIFICATION_ENUM_DISPLAY_MODE_MAPPER: Readonly<Record<SpecificationEnumDisplayMode, string>> =
  Object.freeze({
    [SpecificationEnumDisplayMode.DEFAULT]: 'Default',
    [SpecificationEnumDisplayMode.DROPDOWN]: 'Dropdown',
    [SpecificationEnumDisplayMode.TILES]: 'Tiles',
  });

export const SpecificationEnumDisplayModeOptions: ISelectOption[] = castToOption(
  SpecificationEnumDisplayMode,
  SPECIFICATION_ENUM_DISPLAY_MODE_MAPPER
);
